import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Button,
    InputControl,
    CheckboxControl,
    SegmentLoader,
    Row,
    Col,
    ButtonGroup,
    RadioControl,
    FieldsetControl,
} from '@si-armes/dsfr-react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import { getTelFormatWithoutSpace } from 'components/Commun/Form/maskFunctions';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL,
    API_COMPTE_CREER_ADRESSE_RESPONSABLE_LEGAL_URL,
    API_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE_URL,
    API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL,
    API_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL_URL,
    API_POST_VERIFIER_BAN,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_RESPONSABLE_LEGAL,
    CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL,
    CONTEXT_POST_VERIFIER_BAN,
} from 'constants/apiUrls.constants';
import { REGEXP_EMAIL } from 'constants/contraintes.constants';
import { getMessageErreurChampManquant } from 'utils/utils';
import ModalBan from 'components/modalBan/ModalBan';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import FormulaireJustificatifsDomicile from 'components/form/formulaireAdresse/FormulaireJustificatifsDomicile';
import FormulaireCertificatMedical from 'components/form/certificatMedical/FormulaireCertificatMedical';
import formaterCreationAdressePrincipal from './FormaterCreationAdressePrincipal';
import InfoChampsObligatoire from '../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';
import { hideAllNotification } from '../../../../../../store/alertes/alertesReducer';

const CreerCompteAdresse = ({
    title,
    renderFormProvider = true,
    afficherInformations = true,
    afficherJustificatifDomicile = true,
    afficherCertificatMedical = true,
    afficherItenerant = true,
    desactiverChamps = false,
    callApiAdressePrincipale = true,
    setSuccessSubmit = () => {},
    onLoadingChange = () => {},
    onJustificatifsChange = () => {},
    getAddress = () => {},

    autofilledFields = {},
    uuidBrouillon,
    postApi,
    reinitialiseApi,
    setEtapeAdresse,
    isAncienLicencie,
    data,
    isLoading,
    retourEtape,
    isLoadingRenseignerAdressePrincipale,
    dataRenseignerAdressePrincipale,
    isLoadingRenseignerAdresseResponsableLegal,
    dataRenseignerAdresseResponsableLegal,
    dataAdressePrincipaleRenseignee,
    motifs,
    isLoadingJustificatifsDomicile,
    dataRenseignerJustificatifsDomicile,
    erreurJustificatifsDomicile,
    isLoadingJustificatifsDomicileResponsableLegal,
    dataRenseignerJustificatifsDomicileResponsableLegal,
    erreurJustificatifsDomicileResponsableLegal,
    isLoadingCertificatMedicalArs,
    dataRenseignerCertificatMedicalArs,
    erreurCertificatMedicalArs,
    dataCodePostal,
    clearAlertes,
    isResponsableLegal = false,
    adresseMineur = null,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: { ...dataAdressePrincipaleRenseignee, adresseIdentique: null },
    });

    const { handleSubmit, register, formState, getValues, watch, reset, setValue, unregister } =
        renderFormProvider ? hookForm : useFormContext();

    const { isValid } = formState;
    const [adresseResponsable, setAdresseResponsable] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);
    const [justificatifsDomicile, setJustificatifsDomicile] = useState(null);
    const [certificatMedicalArs, setCertificatMedicalArs] = useState(null);
    const [adresseIdentiqueChoisie, setAdresseIdentiqueChoisie] = useState(null);
    const adresseIdentiqueRef = useRef(null);

    const apiAdresseUrl = isResponsableLegal
        ? API_COMPTE_CREER_ADRESSE_RESPONSABLE_LEGAL_URL
        : API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL;
    const contextAdresse = isResponsableLegal
        ? CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_RESPONSABLE_LEGAL
        : CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE;
    const apiJustificatifDomicileUrl = isResponsableLegal
        ? API_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL_URL
        : API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL;
    const contextJustificatifDomicile = isResponsableLegal
        ? CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_ADRESSE_RESPONSABLE_LEGAL
        : CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2;

    const isLoadingRenseignerAdresseActif = isResponsableLegal
        ? isLoadingRenseignerAdresseResponsableLegal
        : isLoadingRenseignerAdressePrincipale;
    const dataRenseignerAdresseActif = isResponsableLegal
        ? dataRenseignerAdresseResponsableLegal
        : dataRenseignerAdressePrincipale;
    const isLoadingJustificatifsDomicileActif = isResponsableLegal
        ? isLoadingJustificatifsDomicileResponsableLegal
        : isLoadingJustificatifsDomicile;
    const dataRenseignerJustificatifsDomicileActif = isResponsableLegal
        ? dataRenseignerJustificatifsDomicileResponsableLegal
        : dataRenseignerJustificatifsDomicile;
    const erreurJustificatifsDomicileActif = isResponsableLegal
        ? erreurJustificatifsDomicileResponsableLegal
        : erreurJustificatifsDomicile;

    const isLoadingGlobal =
        isLoading ||
        isLoadingRenseignerAdresseActif ||
        isLoadingJustificatifsDomicileActif ||
        isLoadingCertificatMedicalArs;

    const email = watch('email');
    const adresseIdentique = watch('adresseIdentique');

    // Préremplir l'adresse si responsable légal et adresse identique
    useEffect(() => {
        if (!isResponsableLegal || !adresseMineur) {
            return;
        }

        // Convertir en booléen car RadioControl peut retourner des strings
        const estOui = adresseIdentique === true || adresseIdentique === 'true';
        const etaitOui =
            adresseIdentiqueRef.current === true || adresseIdentiqueRef.current === 'true';

        // Mettre à jour l'état pour le disabled
        if (adresseIdentique !== null && adresseIdentique !== undefined) {
            setAdresseIdentiqueChoisie(estOui);
        }

        // Préremplir quand on passe à "Oui"
        if (estOui && !etaitOui) {
            setValue('numeroDeVoie', adresseMineur.numeroDeVoie || '', { shouldValidate: true });
            setValue('typeEtNomDeVoie', adresseMineur.typeEtNomDeVoie || '', {
                shouldValidate: true,
            });
            setValue('extension', adresseMineur.extension || '', { shouldValidate: true });
            setValue('lieuDit', adresseMineur.lieuDit || '', { shouldValidate: true });
            setValue('codePostal', adresseMineur.codePostal || '', { shouldValidate: true });
            setValue('ville', adresseMineur.ville || '', { shouldValidate: true });
            setValue('itinerant', adresseMineur.itinerant || false, { shouldValidate: true });
            setValue('immatriculationVehicule', adresseMineur.immatriculationVehicule || '', {
                shouldValidate: true,
            });
            setValue('typeJustificatif', adresseMineur.typeJustificatif || '', {
                shouldValidate: true,
            });
            setValue('justificatifsDomicile', adresseMineur.justificatifsDomicile || [], {
                shouldValidate: true,
            });
        }

        adresseIdentiqueRef.current = adresseIdentique;
    }, [adresseIdentique, adresseMineur, isResponsableLegal, setValue]);

    const onSubmit = async (dataForm) => {
        const adresseAverifier = {
            numeroVoie: dataForm.numeroDeVoie,
            libelleVoie: dataForm.typeEtNomDeVoie,
            codePostal: dataForm.codePostal,
            ville: dataForm.ville,
            extension: dataForm.extension,
            lieuDit: dataForm.lieuDit,
        };
        clearAlertes();
        setAdresseResponsable(dataForm);

        await reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);

        await postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setOuvrirModalBan(true);
    };

    const renderrenderFormProviderProvider = (children) => {
        if (renderFormProvider) {
            return (
                <SegmentLoader
                    isLoading={
                        isLoading ||
                        isLoadingRenseignerAdresseActif ||
                        isLoadingJustificatifsDomicileActif ||
                        isLoadingCertificatMedicalArs
                    }
                >
                    <FormProvider {...hookForm}>
                        <form onSubmit={handleSubmit(onSubmit)}>{children}</form>
                    </FormProvider>
                </SegmentLoader>
            );
        }
        return children;
    };

    const numeroNonFrancais = (telephone) => {
        if (watch(telephone) && watch(telephone).length > 10) {
            return {
                message:
                    'Le format du numéro de téléphone ne correspond pas à un numéro de téléphone français',
            };
        }
        return null;
    };

    // on mount et unmount
    useEffect(() => {
        if (renderFormProvider) {
            window.scrollTo(0, 0);
        }

        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        reinitialiseApi(contextAdresse);
        if (
            dataAdressePrincipaleRenseignee &&
            dataAdressePrincipaleRenseignee.justificatifsDomicile
        ) {
            setValue(
                'justificatifsDomicile',
                dataAdressePrincipaleRenseignee.justificatifsDomicile,
            );
        }

        if (dataAdressePrincipaleRenseignee && dataAdressePrincipaleRenseignee.certificatMedical) {
            setValue('certificatMedical', dataAdressePrincipaleRenseignee.certificatMedical);
        }

        return () => {
            reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
            reinitialiseApi(contextAdresse);
        };
    }, []);

    // Notifier le parent quand les fichiers justificatifs changent
    useEffect(() => {
        const hasFiles =
            justificatifsDomicile &&
            Array.isArray(justificatifsDomicile) &&
            justificatifsDomicile.length > 0;
        onJustificatifsChange(hasFiles);
    }, [justificatifsDomicile, onJustificatifsChange]);

    async function postJustificatifsDomicile() {
        reinitialiseApi(contextJustificatifDomicile);
        justificatifsDomicile.forEach((value, index) => {
            postApi(
                usagerClientReducer,
                apiJustificatifDomicileUrl.replace('{index}', index + 1),
                {
                    justificatifDomicile: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                contextJustificatifDomicile,
            );
        });
    }

    async function postCertificatMedicalArs() {
        reinitialiseApi(
            CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
        );
        postApi(
            usagerClientReducer,
            API_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE_URL,
            {
                certificatMedical: certificatMedicalArs,
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
        );
    }

    useEffect(() => {
        if (
            !isLoadingRenseignerAdresseActif &&
            dataRenseignerAdresseActif &&
            dataRenseignerAdresseActif.uuidBrouillon
        ) {
            setOuvrirModalBan(false);

            if (justificatifsDomicile) {
                postJustificatifsDomicile();
            }

            if (certificatMedicalArs) {
                postCertificatMedicalArs();
            }
        }
    }, [isLoadingRenseignerAdresseActif, dataRenseignerAdresseActif]);

    function conditionPourPasserEtapeSuivante() {
        const adresseEnvoyee = Boolean(
            !isLoadingRenseignerAdresseActif &&
                dataRenseignerAdresseActif &&
                dataRenseignerAdresseActif.uuidBrouillon,
        );

        const justificatifDomicileEnvoyee =
            isLoadingJustificatifsDomicileActif === false &&
            dataRenseignerJustificatifsDomicileActif &&
            !erreurJustificatifsDomicileActif;

        const certificatMedicalArsEnvoyee =
            isLoadingCertificatMedicalArs === false &&
            dataRenseignerCertificatMedicalArs &&
            !erreurCertificatMedicalArs;

        if (!afficherJustificatifDomicile && !afficherCertificatMedical) {
            return adresseEnvoyee;
        }

        if (!afficherJustificatifDomicile) {
            return adresseEnvoyee && certificatMedicalArsEnvoyee;
        }

        if (!afficherCertificatMedical) {
            return adresseEnvoyee && justificatifDomicileEnvoyee;
        }

        return adresseEnvoyee && (justificatifDomicileEnvoyee || certificatMedicalArsEnvoyee);
    }

    const reinitialiseAllApi = () => {
        if (afficherCertificatMedical) {
            reinitialiseApi(
                CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
            );
        }

        if (afficherJustificatifDomicile) {
            reinitialiseApi(contextJustificatifDomicile);
        }

        reinitialiseApi(contextAdresse);
    };

    useEffect(() => {
        if (!renderFormProvider && conditionPourPasserEtapeSuivante()) {
            reinitialiseAllApi();
            setSuccessSubmit(conditionPourPasserEtapeSuivante());
        }

        if (renderFormProvider && conditionPourPasserEtapeSuivante()) {
            reinitialiseAllApi();
            setEtapeAdresse(adresseResponsable);
        }
    }, [
        isLoadingRenseignerAdresseActif,
        dataRenseignerAdresseActif,
        isLoadingJustificatifsDomicileActif,
        dataRenseignerJustificatifsDomicileActif,
        erreurJustificatifsDomicileActif,
        isLoadingCertificatMedicalArs,
        dataRenseignerCertificatMedicalArs,
        erreurCertificatMedicalArs,
    ]);

    const hasFormValid = () => {
        const adresseValide = (watch('typeEtNomDeVoie') || watch('lieuDit')) && dataCodePostal;

        if (isResponsableLegal) {
            const emailValide = email && REGEXP_EMAIL.test(email);
            const telephoneValide = watch('telephonePrincipal');
            const justificatifsDomicileForm = watch('justificatifsDomicile');
            const justificatifPresent =
                justificatifsDomicileForm && justificatifsDomicileForm.length > 0;
            const adresseIdentiqueSelectionnee =
                adresseIdentique !== null && adresseIdentique !== undefined;

            return (
                adresseIdentiqueSelectionnee &&
                adresseValide &&
                emailValide &&
                telephoneValide &&
                justificatifPresent
            );
        }

        return adresseValide && isValid;
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    function postAdresse(donnees) {
        reinitialiseApi(contextAdresse);
        getAddress(donnees);

        if (callApiAdressePrincipale) {
            const payload = isResponsableLegal
                ? {
                      ...donnees,
                      itinerant: Boolean(
                          adresseResponsable?.itinerant === true ||
                              adresseResponsable?.itinerant === 'true',
                      ),
                      adresseIdentique:
                          adresseResponsable?.adresseIdentique === true ||
                          adresseResponsable?.adresseIdentique === 'true',
                  }
                : donnees;

            postApi(usagerClientReducer, apiAdresseUrl, payload, contextAdresse);
        }

        if (donnees && !afficherJustificatifDomicile && !afficherCertificatMedical) {
            setSuccessSubmit(true);
        }
    }

    const conserver = async () => {
        setOuvrirModalBan(false);
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            false,
        );
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        setCertificatMedicalArs(dataFormat.certificatMedical);
        dataFormat.certificatMedical = null;
        postAdresse(dataFormat);
    };

    const remplacer = async () => {
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            true,
        );
        dataFormat.numeroDeVoie = data.numeroVoie;
        dataFormat.typeEtNomDeVoie = data.libelleVoie;
        dataFormat.extension = data.extension;
        dataFormat.lieuDit = data.lieuDit;
        dataFormat.codePostal = data.codePostal;
        dataFormat.ville = data.ville;

        const champsARemplacer = {
            numeroDeVoie: data.numeroVoie,
            typeEtNomDeVoie: data.libelleVoie.toUpperCase(),
            extension: data.extension,
            lieuDit: data.lieuDit,
            codePostal: data.codePostal,
            ville: data.ville.toUpperCase(),
            email: dataFormat.email,
            numeroSia: dataFormat.numeroSia,
            telephonePrincipal: dataFormat.telephonePrincipal,
            telephoneSecondaire: dataFormat.telephoneSecondaire,
            immatriculationVehicule: dataFormat.immatriculationVehicule,
            typeJustificatifDomicile: dataFormat.typeJustificatifDomicile,
        };

        reset(champsARemplacer);

        setAdresseResponsable({
            ...adresseResponsable,
            ...champsARemplacer,
        });

        setOuvrirModalBan(false);
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        setCertificatMedicalArs(dataFormat.certificatMedical);
        dataFormat.certificatMedical = null;
        await postAdresse(dataFormat);
    };

    useEffect(() => {
        if (!renderFormProvider && formState?.isSubmitSuccessful) {
            onSubmit(getValues());
        }
    }, [formState?.submitCount]);

    useEffect(() => {
        onLoadingChange(isLoadingGlobal);
    }, [isLoadingGlobal]);

    return (
        <>
            {ouvrirModalBan && (
                <ModalBan
                    residence="principale"
                    fermerModal={fermerModal}
                    data={data}
                    isLoading={isLoadingGlobal}
                    remplacer={remplacer}
                    conserver={conserver}
                />
            )}
            {renderrenderFormProviderProvider(
                <>
                    {renderFormProvider && (
                        <Row>
                            <Col col={12}>
                                <InfoChampsObligatoire />
                            </Col>
                        </Row>
                    )}
                    <Row className={!renderFormProvider ? 'margin-top-lg' : ''}>
                        <Col col={12}>
                            <h3>{title ?? 'Adresse postale en France'}</h3>
                            {motifs?.isMineur && !isResponsableLegal && (
                                <p className="text--sm">
                                    L'adresse de résidence principale du détenteur mineur correspond
                                    à l'adresse où sont stockées ses armes
                                </p>
                            )}
                        </Col>
                    </Row>
                    {isResponsableLegal && (
                        <Row gutters>
                            <Col col={12}>
                                <FieldsetControl
                                    legend="L'adresse de résidence principale du responsable légal est-elle la même que celle du détenteur mineur ?"
                                    state={formState.errors?.adresseIdentique ? 'error' : null}
                                    message={formState.errors?.adresseIdentique?.message}
                                    inline
                                >
                                    <RadioControl
                                        id="adresseIdentique-oui"
                                        label="Oui"
                                        value
                                        disabled={adresseIdentiqueChoisie === false}
                                        {...register('adresseIdentique', {
                                            required: 'Veuillez sélectionner une option',
                                            onChange: () => {
                                                setAdresseIdentiqueChoisie(true);
                                            },
                                        })}
                                    />
                                    <RadioControl
                                        id="adresseIdentique-non"
                                        label="Non"
                                        value={false}
                                        disabled={adresseIdentiqueChoisie === true}
                                        {...register('adresseIdentique', {
                                            required: 'Veuillez sélectionner une option',
                                            onChange: () => {
                                                setAdresseIdentiqueChoisie(false);
                                            },
                                        })}
                                    />
                                </FieldsetControl>
                            </Col>
                        </Row>
                    )}
                    <FormulaireAdresseSimple
                        desactiverChamps={desactiverChamps}
                        autofilledFields={autofilledFields}
                    />

                    {afficherJustificatifDomicile && <FormulaireJustificatifsDomicile />}

                    {afficherItenerant && (
                        <Row gutters>
                            <Col col={12} lg={6}>
                                <CheckboxControl
                                    id="itinerant"
                                    name="itinerant"
                                    label="Itinérant"
                                    value="itinerant"
                                    {...register('itinerant', {
                                        onChange: ({ target }) => {
                                            if (!target.checked) {
                                                unregister('immatriculationVehicule');
                                            }
                                        },
                                    })}
                                />
                                {watch('itinerant') && (
                                    <div>
                                        <InputControl
                                            id="immatriculationVehicule"
                                            uppercase
                                            label="Immatriculation de votre résidence mobile terrestre"
                                            hintText="Caravane, camping-car,..."
                                            {...register('immatriculationVehicule', {
                                                required: getMessageErreurChampManquant(
                                                    'Immatriculation du véhicule',
                                                ),
                                                setValueAs: (v) => v.toUpperCase(),
                                            })}
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>
                    )}

                    {afficherInformations && (
                        <>
                            <Row className="margin-top-lg">
                                <Col col={12}>
                                    <h3>Informations</h3>
                                </Col>
                            </Row>
                            <Row gutters>
                                <Col col={12} lg={6}>
                                    <InputControl
                                        autocomplete="email"
                                        id="email"
                                        label="E-mail *"
                                        hintText="Exemple: ministere.interieur@exemple.com"
                                        type="text"
                                        required
                                        {...register('email', {
                                            required: getMessageErreurChampManquant('E-mail'),
                                            pattern: {
                                                value: REGEXP_EMAIL,
                                                message:
                                                    "Le format de l'adresse mail n'est pas valide ( Exemple: ministere.interieur@exemple.com )",
                                            },
                                        })}
                                        state={formState.errors?.email ? 'error' : null}
                                        message={formState.errors?.email?.message}
                                    />
                                </Col>
                            </Row>
                            <Row gutters>
                                <Col col={12} lg={6}>
                                    <InputControl
                                        autocomplete="tel-national"
                                        id="telephonePrincipal"
                                        label="Téléphone *"
                                        hintText="Exemple: 0612345678"
                                        required
                                        type="text"
                                        maxLength="10"
                                        {...register('telephonePrincipal', {
                                            required: getMessageErreurChampManquant('Téléphone'),
                                        })}
                                        state={
                                            formState.errors?.telephonePrincipal ? 'error' : null
                                        }
                                        message={formState.errors?.telephonePrincipal?.message}
                                        warning={numeroNonFrancais('telephonePrincipal')}
                                        maskFonction={getTelFormatWithoutSpace}
                                    />
                                </Col>
                                <Col col={12} lg={6}>
                                    <InputControl
                                        autocomplete="tel-national"
                                        id="telephoneSecondaire"
                                        label="Téléphone"
                                        hintText="Exemple: 0198765432"
                                        type="text"
                                        maxLength="10"
                                        {...register('telephoneSecondaire')}
                                        state={
                                            formState.errors?.telephoneSecondaire ? 'error' : null
                                        }
                                        message={formState.errors?.telephoneSecondaire?.message}
                                        warning={numeroNonFrancais('telephoneSecondaire')}
                                        maskFonction={getTelFormatWithoutSpace}
                                    />
                                </Col>
                            </Row>

                            {((motifs && motifs.isNonLicencie) ||
                                (motifs && motifs.isLicencie && isAncienLicencie)) && (
                                <FormulaireCertificatMedical isAncienLicencie={isAncienLicencie} />
                            )}
                        </>
                    )}

                    {renderFormProvider && (
                        <Row className="margin-top-lg">
                            <Col>
                                <ButtonGroup inline align="right">
                                    <Button
                                        name="etapePrecedente"
                                        type="button"
                                        variant="secondary"
                                        isLoading={isLoadingGlobal}
                                        onClick={retourEtape}
                                    >
                                        Retour
                                    </Button>
                                    <Button
                                        name="etapeSuivante"
                                        type="submit"
                                        variant="primary"
                                        isLoading={isLoadingGlobal}
                                        disabled={!hasFormValid()}
                                    >
                                        Accéder à l'étape suivante
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    )}
                </>,
            )}
        </>
    );
};

CreerCompteAdresse.propTypes = {
    title: PropTypes.string,
    uuidBrouillon: PropTypes.string.isRequired,
    postApi: PropTypes.func.isRequired,
    getAddress: PropTypes.func.isRequired,
    setEtapeAdresse: PropTypes.func.isRequired,
    isAncienLicencie: PropTypes.bool,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    callApiAdressePrincipale: PropTypes.bool,
    data: PropTypes.any,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    isLoadingRenseignerAdressePrincipale: PropTypes.bool.isRequired,
    dataRenseignerAdressePrincipale: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    isLoadingRenseignerAdresseResponsableLegal: PropTypes.bool,
    dataRenseignerAdresseResponsableLegal: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    isLoadingJustificatifsDomicile: PropTypes.bool,
    dataRenseignerJustificatifsDomicile: PropTypes.string.isRequired,
    erreurJustificatifsDomicile: PropTypes.bool,
    isLoadingJustificatifsDomicileResponsableLegal: PropTypes.bool,
    dataRenseignerJustificatifsDomicileResponsableLegal: PropTypes.string,
    erreurJustificatifsDomicileResponsableLegal: PropTypes.bool,
    isLoadingCertificatMedicalArs: PropTypes.bool,
    dataRenseignerCertificatMedicalArs: PropTypes.string.isRequired,
    erreurCertificatMedicalArs: PropTypes.bool,
    dataAdressePrincipaleRenseignee: PropTypes.shape({
        numeroDeVoie: PropTypes.string,
        typeEtNomDeVoie: PropTypes.string.isRequired,
        extension: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string.isRequired,
        ville: PropTypes.string.isRequired,
        typeJustificatif: PropTypes.string.isRequired,
        justificatifsDomicile: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract))
            .isRequired,
        certificatMedical: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        itinerant: PropTypes.string,
        immatriculationVehicule: PropTypes.string,
        email: PropTypes.string,
        telephonePrincipal: PropTypes.string,
        telephoneSecondaire: PropTypes.string,
    }),
    dataCodePostal: PropTypes.bool,
    clearAlertes: PropTypes.func,
    renderFormProvider: PropTypes.bool,
    afficherInformations: PropTypes.bool,
    afficherJustificatifDomicile: PropTypes.bool,
    afficherCertificatMedical: PropTypes.bool,
    autofilledFields: PropTypes.object,
    desactiverChamps: PropTypes.bool,
    afficherItenerant: PropTypes.bool,
    setSuccessSubmit: PropTypes.func,
    onLoadingChange: PropTypes.func,
    onJustificatifsChange: PropTypes.func,
    isResponsableLegal: PropTypes.bool,
    adresseMineur: PropTypes.shape({
        numeroDeVoie: PropTypes.string,
        typeEtNomDeVoie: PropTypes.string,
        extension: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string,
        ville: PropTypes.string,
        itinerant: PropTypes.bool,
        immatriculationVehicule: PropTypes.string,
    }),
};
export default connect(
    (state) => {
        const { isLoading, data } = state.adresseVerificationBAN.verifier;

        const {
            isLoading: isLoadingRenseignerAdressePrincipale,
            data: dataRenseignerAdressePrincipale,
        } = state.compte.creer.renseignerAdressePrincipale;

        const {
            isLoading: isLoadingRenseignerAdresseResponsableLegal,
            data: dataRenseignerAdresseResponsableLegal,
        } = state.compte.creer.renseignerAdresseResponsableLegal || {};

        const {
            data: dataRenseignerJustificatifsDomicile,
            isLoading: isLoadingJustificatifsDomicile,
            erreur: erreurJustificatifsDomicile,
        } = state.compte.creer.renseignerJustificatifsDomicile;
        const {
            data: dataRenseignerJustificatifsDomicileResponsableLegal,
            isLoading: isLoadingJustificatifsDomicileResponsableLegal,
            erreur: erreurJustificatifsDomicileResponsableLegal,
        } = state.compte.creer.renseignerJustificatifsDomicileResponsableLegal || {};
        const {
            data: dataRenseignerCertificatMedicalArs,
            isLoading: isLoadingCertificatMedicalArs,
            erreur: erreurCertificatMedicalArs,
        } = state.compte.creer.renseignerCertificatMedicalArs;
        const { data: dataCodePostal } = state.monCompte.verifierCodePostal;

        return {
            isLoading,
            data,
            isLoadingRenseignerAdressePrincipale,
            dataRenseignerAdressePrincipale,
            isLoadingRenseignerAdresseResponsableLegal,
            dataRenseignerAdresseResponsableLegal,
            isLoadingJustificatifsDomicile,
            dataRenseignerJustificatifsDomicile,
            erreurJustificatifsDomicile,
            isLoadingJustificatifsDomicileResponsableLegal,
            dataRenseignerJustificatifsDomicileResponsableLegal,
            erreurJustificatifsDomicileResponsableLegal,
            isLoadingCertificatMedicalArs,
            dataRenseignerCertificatMedicalArs,
            erreurCertificatMedicalArs,
            dataCodePostal,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
        clearAlertes: hideAllNotification,
    },
)(CreerCompteAdresse);
